import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import {
  PERIOD_UNIT,
  AFTER_CURRENT_PURPOSE,
  DRIVER_LICENSE_COLOR,
  GENDER,
  LINE_MESSAGE_TYPE,
  DRIVER_LIMITED_CONDITION,
  DRIVER_AGE_CONDITION,
  APPLICABLE_CHECK,
  CAR_INSURANCE_TYPE
} from 'const';
import AsyncButton from 'utils/AsyncButton';
import CloseIcon from '@material-ui/icons/Close';
import ModalWrapper from 'utils/ModalWrapper';
import BeforeSendConfirm from '../BeforeSendConfirm';
import coverageImg from 'images/coverageImg.png';
import columns from 'utils/DriverCompensationsData';
import { convertToJapaneseCalendar } from 'utils/japaneseCalendarConverter';
import { getAcceptanceStatus } from 'utils/AcceptanceStatus';
import { TABLE_PATTERN } from 'utils/tableMapping';
import { convertDateSeparator } from 'utils/utils';

const ChatInputConfirm = (props) => {
  // 金額のカンマ区切り
  const formatter = new Intl.NumberFormat('ja-JP');

  const {
    detailData,
    chatHistory,
    chatInputFormik,
    isChatSubmitInProgress,
    closeModal,
    canSend,
  } = props;

  const chatInput = detailData.chatInput;
  const [confirmModal, setConfirmModal] = useState(false);

  const tablePattern = () => {
    let tablePattern;
    if (canSend) {
      tablePattern = TABLE_PATTERN.find(
        (pattern) =>
          chatInputFormik.values.isPersonalAndInsuranceStartTerm ===
          pattern.isPersonalAndInsuranceStartTerm &&
          chatInputFormik.values.updatedDriverAgeConditionSpecialContract ===
          pattern.updatedDriverAgeConditionSpecialContract &&
          chatInputFormik.values.updatedDriverSpecialContract ===
          pattern.updatedDriverSpecialContract
      );
    } else {
      tablePattern = TABLE_PATTERN.find(
        (pattern) =>
          chatHistory?.isPersonalAndInsuranceStartTerm ===
          pattern.isPersonalAndInsuranceStartTerm &&
          chatHistory?.updatedDriverAgeConditionSpecialContract ===
          pattern.updatedDriverAgeConditionSpecialContract &&
          chatHistory?.updatedDriverSpecialContract ===
          pattern.updatedDriverSpecialContract
      );
    }
    return tablePattern ? tablePattern.pattern : '';
  };
  const tableData = columns(tablePattern());

  const isOnlyOnePlan = () => {
    // 新価特約の「追加・返戻」と「変更保険料」のどちらかがnullであれば、プランは一つ扱い（=新価特約はなし）にする。
    if (canSend) {
      return (
        chatInputFormik.values.newCarSpecialContractAddOrMinus === null ||
        chatInputFormik.values.newCarSpecialContractUpdatedInsuranceFee === null
      );
    } else {
      return (
        chatHistory?.newCarSpecialContractAddOrMinus === null ||
        chatHistory?.newCarSpecialContractUpdatedInsuranceFee === null
      );
    }
  };

  const getUpdatedInsuranceLabel = (addOrMinus) => {
    if (addOrMinus === 1) {
      return '追加保険料：';
    } else if (addOrMinus === 2) {
      return '返還保険料：';
    }
  };

  return (
    <>
      <CloseIcon
        fontSize='large'
        className={styles.closeImg}
        onClick={closeModal}
      />
      <div className={styles.confirmPage}>
        {canSend && (
          <div className={styles.confirmPageAlert}>
            {chatInputFormik.values.isLongTermContract === 1 && (
              <div>
                長期契約です。長期契約入力箇所（車両保険金額、保険料）に漏れがないか今一度確認してください。
              </div>
            )}
            {(chatInputFormik.values.carInsuranceType === 1 ||
              chatInputFormik.values.carInsuranceType === 2) && (
                <div>
                  新価特約が付帯できる契約の場合、新価特約入力欄（保険料）の入力漏れがないか今一度確認してください。
                </div>
              )}
          </div>
        )}
        {!canSend && (
          <div className={styles.confirmPageHeader}>
            <span className={styles.confirmPageHeaderSpace}>
              送信日時：{convertDateSeparator(chatHistory?.sendLineAt)}
            </span>
            <span className={styles.confirmPageHeaderSpace}>
              回答日時：{convertDateSeparator(chatHistory?.answeredAt)}
            </span>
            <span className={styles.confirmPageHeaderSpace}>
              回答結果：{getAcceptanceStatus(chatHistory)}
            </span>
          </div>
        )}
        <div className={styles.confirmPageTitle}> LINEメッセージ</div>
        <div className={styles.confirmPageItemArea}>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>チャット種別</p>
            <p className={styles.text}>
              {canSend
                ? LINE_MESSAGE_TYPE[chatInputFormik.values.messageType]
                : LINE_MESSAGE_TYPE[chatHistory?.messageType]}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>メッセージ</p>
            <p className={styles.text}>
              {canSend ? chatInputFormik.values.message : chatHistory?.message}
            </p>
          </div>
        </div>
        <div className={styles.confirmPageTitle}> 基本情報</div>
        <div className={styles.confirmPageItemArea}>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>受付日時</p>
            <p className={styles.text}>
              {canSend
                ? convertToJapaneseCalendar(chatInput?.receptionDatetime)
                : convertToJapaneseCalendar(chatHistory?.receptionDatetime)}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>証券番号</p>
            <p className={styles.text}>
              {canSend ? chatInput?.policyNumber : chatHistory?.policyNumber}
            </p>
          </div>
          {(canSend ? chatInput?.detailNumber : chatHistory?.detailNumber) && (
            <div className={styles.confirmPageItem}>
              <p className={styles.labelTop}>明細番号</p>
              <p className={styles.text}>
                {canSend ? chatInput?.detailNumber : chatHistory?.detailNumber}
              </p>
            </div>
          )}
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>契約者名</p>
            <p className={styles.text}>
              {canSend ? chatInput?.name : chatHistory?.name}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>現在の契約自動車名</p>
            <p className={styles.text}>
              {canSend
                ? chatInputFormik.values.currentContractCarName
                : chatHistory?.currentContractCarName}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>現在の契約自動車 登録番号下４桁</p>
            <p className={styles.text}>
              {canSend
                ? chatInputFormik.values.currentContractCarRegistrationNumber
                : chatHistory?.currentContractCarRegistrationNumber}
            </p>
          </div>
          <div className={styles.confirmPageItem}>
            <p className={styles.labelTop}>変更日</p>
            <p className={styles.text}>
              {canSend
                ? convertToJapaneseCalendar(chatInput?.changeDate)
                : convertToJapaneseCalendar(chatHistory?.changeDate)}
            </p>
          </div>
        </div>
        {detailData.vehicle?.id && (
          <>
            <div className={styles.confirmPageTitle}>
              お車の買い替えに伴う変更
            </div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>変更後の契約自動車名</p>
                <p className={styles.text}>
                  {canSend
                    ? chatInputFormik.values.updatedContractCarName
                    : chatHistory?.updatedContractCarName}
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>初度登録年月</p>
                <p className={styles.text}>
                  {canSend
                    ? chatInputFormik.values.yearAndMonthOfFirstRegistration
                    : chatHistory?.yearAndMonthOfFirstRegistration}
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>型式</p>
                <p className={styles.text}>
                  {canSend
                    ? chatInputFormik.values.carModel
                    : chatHistory?.carModel}
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>変更後の契約自動車登録番号</p>
                <p className={styles.text}>
                  {canSend
                    ? chatInputFormik.values
                      .updatedContractCarRegistrationNumber
                    : chatHistory?.updatedContractCarRegistrationNumber}
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>車台番号</p>
                <p className={styles.text}>
                  {canSend
                    ? chatInputFormik.values.chassisNumber
                    : chatHistory?.chassisNumber}
                </p>
              </div>
              {(canSend
                ? chatInputFormik.values.carType
                : chatHistory?.carType) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>用途車種</p>
                    <p className={styles.text}>
                      {canSend
                        ? chatInputFormik.values.carType
                        : chatHistory?.carType}
                    </p>
                  </div>
                )}
              {(canSend
                ? chatInputFormik.values.baseLocationForUse
                : chatHistory?.baseLocationForUse) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>使用の本拠地</p>
                    <p className={styles.text}>
                      {canSend
                        ? chatInputFormik.values.baseLocationForUse
                        : chatHistory?.baseLocationForUse}
                    </p>
                  </div>
                )}
              {(canSend
                ? chatInputFormik.values.carOwnerKana ||
                chatInputFormik.values.carOwner
                : chatHistory?.carOwnerKana || chatHistory?.carOwner) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>
                      車両の所有者（所有権留保またはリースカーの場合は買主または借主）
                    </p>
                    <p className={styles.text}>
                      {canSend
                        ? chatInputFormik.values.carOwnerKana
                        : chatHistory?.carOwnerKana}
                    </p>
                    <p className={styles.text}>
                      {canSend
                        ? chatInputFormik.values.carOwner
                        : chatHistory?.carOwner}
                    </p>
                  </div>
                )}
              {(canSend
                ? chatInputFormik.values.carInsuranceType
                : chatHistory?.carInsuranceType) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>
                      車両保険のタイプ
                    </p>
                    <p className={styles.text}>
                      {canSend
                        ? CAR_INSURANCE_TYPE[chatInputFormik.values.carInsuranceType]
                        : CAR_INSURANCE_TYPE[chatHistory?.carInsuranceType]}
                    </p>
                  </div>
                )}
              <div className={styles.confirmPageItem}>
                {(canSend
                  ? ((chatInputFormik.values.updatedCarInsuranceFee || chatInputFormik.values.updatedCarInsuranceFee === 0) ||
                    (chatInputFormik.values.carInsuranceFeeNextYear || chatInputFormik.values.carInsuranceFeeNextYear === 0) ||
                    (chatInputFormik.values.carInsuranceFeeThirdYear || chatInputFormik.values.carInsuranceFeeThirdYear === 0))
                  : ((chatHistory?.updatedCarInsuranceFee || chatHistory?.updatedCarInsuranceFee === 0) ||
                    (chatHistory?.carInsuranceFeeNextYear || chatHistory?.carInsuranceFeeNextYear === 0) ||
                    (chatHistory?.carInsuranceFeeThirdYear || chatHistory?.carInsuranceFeeThirdYear === 0))) && (
                    <p className={styles.labelTop}>変更後の車両保険金額</p>
                  )}
                {(canSend
                  ? (chatInputFormik.values.updatedCarInsuranceFee || chatInputFormik.values.updatedCarInsuranceFee === 0)
                  : (chatHistory?.updatedCarInsuranceFee || chatHistory?.updatedCarInsuranceFee === 0)) && (
                    <p className={styles.text}>
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.updatedCarInsuranceFee
                          : chatHistory?.updatedCarInsuranceFee
                      )}
                      万円
                    </p>
                  )}
                {(canSend
                  ? (chatInputFormik.values.carInsuranceFeeNextYear || chatInputFormik.values.carInsuranceFeeNextYear === 0)
                  : (chatHistory?.carInsuranceFeeNextYear || chatHistory?.carInsuranceFeeNextYear === 0)) && (
                    <p className={styles.text}>
                      （長期契約）次年度保険金額：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.carInsuranceFeeNextYear
                          : chatHistory?.carInsuranceFeeNextYear
                      )}
                      万円
                    </p>
                  )}
                {(canSend
                  ? (chatInputFormik.values.carInsuranceFeeThirdYear || chatInputFormik.values.carInsuranceFeeThirdYear === 0)
                  : (chatHistory?.carInsuranceFeeThirdYear || chatHistory?.carInsuranceFeeThirdYear === 0)) && (
                    <p className={styles.text}>
                      （長期契約）三年度目保険金額：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.carInsuranceFeeThirdYear
                          : chatHistory?.carInsuranceFeeThirdYear
                      )}
                      万円
                    </p>
                  )}
              </div>
              <div className={styles.confirmPageItem}>
                {(canSend
                  ? ((chatInputFormik.values.outOfPocketFeeFirstTime || chatInputFormik.values.outOfPocketFeeFirstTime === 0) ||
                    (chatInputFormik.values.outOfPocketFeeAfterSecondTime || chatInputFormik.values.outOfPocketFeeAfterSecondTime === 0))
                  : ((chatHistory?.outOfPocketFeeFirstTime || chatHistory?.outOfPocketFeeFirstTime === 0) ||
                    (chatHistory?.outOfPocketFeeAfterSecondTime || chatHistory?.outOfPocketFeeAfterSecondTime === 0))) && (
                    <p className={styles.labelTop}>車両保険の自己負担額</p>
                  )}
                {(canSend
                  ? (chatInputFormik.values.outOfPocketFeeFirstTime || chatInputFormik.values.outOfPocketFeeFirstTime === 0)
                  : (chatHistory?.outOfPocketFeeFirstTime || chatHistory?.outOfPocketFeeFirstTime === 0)) && (
                    <p className={styles.text}>
                      1回目事故：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.outOfPocketFeeFirstTime
                          : chatHistory?.outOfPocketFeeFirstTime
                      )}
                      万円
                    </p>
                  )}
                {(canSend
                  ? (chatInputFormik.values.outOfPocketFeeAfterSecondTime || chatInputFormik.values.outOfPocketFeeAfterSecondTime === 0)
                  : (chatHistory?.outOfPocketFeeAfterSecondTime || chatHistory?.outOfPocketFeeAfterSecondTime === 0)) && (
                    <p className={styles.text}>
                      2回目以降事故：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.outOfPocketFeeAfterSecondTime
                          : chatHistory?.outOfPocketFeeAfterSecondTime
                      )}
                      万円
                    </p>
                  )}
              </div>
            </div>
          </>
        )}
        {detailData.nenrei?.id && (
          <>
            <div className={styles.confirmPageTitle}>
              年齢条件・運転者限定特約
            </div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>変更後の運転者限定特約</p>
                <p className={styles.text}>
                  {
                    DRIVER_LIMITED_CONDITION[
                    canSend
                      ? chatInputFormik.values.updatedDriverSpecialContract
                      : chatHistory?.updatedDriverSpecialContract
                    ]
                  }
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>変更後の運転者年齢条件特約</p>
                <p className={styles.text}>
                  {
                    DRIVER_AGE_CONDITION[
                    canSend
                      ? chatInputFormik.values
                        .updatedDriverAgeConditionSpecialContract
                      : chatHistory?.updatedDriverAgeConditionSpecialContract
                    ]
                  }
                </p>
              </div>
              <div className={styles.confirmPageItem}>
                {
                  [1, 2].includes(canSend
                    ? chatInputFormik.values.isPersonalAndInsuranceStartTerm
                    : chatHistory?.isPersonalAndInsuranceStartTerm) && <p className={styles.labelTop}>変更後の運転者の補償範囲</p>
                }
                {(canSend
                  ? chatInputFormik.values.isPersonalAndInsuranceStartTerm
                  : chatHistory?.isPersonalAndInsuranceStartTerm) === 1 ? (
                  <TableContainer>
                    <Table size='small' className={styles.coverageTable}>
                      <TableHead>
                        <TableRow>
                          <TableCell>運転者の年齢</TableCell>
                          <TableCell align='right'>20歳以下</TableCell>
                          <TableCell align='right'>21~25歳</TableCell>
                          <TableCell align='right'>26~34歳</TableCell>
                          <TableCell align='right'>35歳以上</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {tableData.map((columns) => (
                          <TableRow key={columns.age}>
                            <TableCell component='th' scope='row'>
                              {columns.age}
                            </TableCell>
                            <TableCell align='center'>
                              {columns.under20}
                            </TableCell>
                            <TableCell align='center'>
                              {columns.under25}
                            </TableCell>
                            <TableCell align='center'>
                              {columns.under34}
                            </TableCell>
                            <TableCell align='center'>
                              {columns.over35}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <p className={styles.coverageCaution}>
                      ※①~③の方の業務に従事中の使用人については年齢条件が適用されます。
                    </p>
                  </TableContainer>
                ) : (canSend
                  ? chatInputFormik.values.isPersonalAndInsuranceStartTerm
                  : chatHistory?.isPersonalAndInsuranceStartTerm) === 2 ? (
                  <img src={coverageImg} alt='変更後の運転者の補償範囲' />
                ) : (
                  ''
                )}
              </div>
              {(canSend
                ? chatInput?.driverLicenseColorOfYoungest
                : chatHistory?.driverLicenseColorOfYoungest) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>
                      変更後の最若年運転者の免許証の色
                    </p>
                    <p className={styles.text}>
                      {canSend
                        ? DRIVER_LICENSE_COLOR[
                        chatInput?.driverLicenseColorOfYoungest
                        ]
                        : DRIVER_LICENSE_COLOR[
                        chatHistory?.driverLicenseColorOfYoungest
                        ]}
                    </p>
                  </div>
                )}
              {(canSend
                ? chatInput?.genderOfYoungest
                : chatHistory?.genderOfYoungest) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>変更後の最若年運転者の性別</p>
                    <p className={styles.text}>
                      {canSend
                        ? GENDER[chatInput?.genderOfYoungest]
                        : GENDER[chatHistory?.genderOfYoungest]}
                    </p>
                  </div>
                )}
            </div>
          </>
        )}
        {detailData.purpose?.id && (
          <>
            <div className={styles.confirmPageTitle}>使用目的変更</div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>変更後の使用目的</p>
                <p className={styles.text}>
                  {canSend
                    ? AFTER_CURRENT_PURPOSE[chatInput?.afterCurrentPurpose]
                    : AFTER_CURRENT_PURPOSE[chatHistory?.afterCurrentPurpose]}
                </p>
              </div>
              {(canSend
                ? chatInput?.forBusinessUseCar
                : chatHistory?.forBusinessUseCar) && (
                  <div className={styles.confirmPageItem}>
                    <p className={styles.labelTop}>
                      業務にのみ利用する自動車か否かの確認
                    </p>
                    <p className={styles.text}>
                      {canSend
                        ? APPLICABLE_CHECK[chatInput?.forBusinessUseCar]
                        : APPLICABLE_CHECK[chatHistory?.forBusinessUseCar]}
                    </p>
                  </div>
                )}
            </div>
          </>
        )}
        <div className={styles.confirmPageTitle}>変更保険料</div>
        <div className={styles.confirmPageItemArea}>
          {isOnlyOnePlan() && (
            <div className={styles.confirmPageItem}>
              <p className={styles.labelTop}>変更保険料</p>
              <p className={styles.text}>
                {canSend
                  ? getUpdatedInsuranceLabel(chatInputFormik.values.addOrMinus)
                  : getUpdatedInsuranceLabel(chatHistory?.addOrMinus)}
                {formatter.format(
                  canSend
                    ? chatInputFormik.values.updatedInsuranceFee
                    : chatHistory?.updatedInsuranceFee
                )}
                円
              </p>
              {(canSend
                ? (chatInputFormik.values.updatedMonthlyInsuranceFee || chatInputFormik.values.updatedMonthlyInsuranceFee === 0)
                : (chatHistory?.updatedMonthlyInsuranceFee || chatHistory?.updatedMonthlyInsuranceFee === 0)) && (
                  <p className={styles.text}>
                    変更後月払保険料：
                    {formatter.format(
                      canSend
                        ? chatInputFormik.values.updatedMonthlyInsuranceFee
                        : chatHistory?.updatedMonthlyInsuranceFee
                    )}
                    円
                  </p>
                )}
              {(canSend
                ? ((chatInputFormik.values.updatedInsuranceFeeOfNextYear || chatInputFormik.values.updatedInsuranceFeeOfNextYear === 0) &&
                  chatInputFormik.values.paymentMethodOfNextYear)
                : ((chatHistory?.updatedInsuranceFeeOfNextYear || chatHistory?.updatedInsuranceFeeOfNextYear === 0) &&
                  chatHistory?.paymentMethodOfNextYear)) && (
                  <p className={styles.text}>
                    （長期契約）次年度保険料：
                    {formatter.format(
                      canSend
                        ? chatInputFormik.values.updatedInsuranceFeeOfNextYear
                        : chatHistory?.updatedInsuranceFeeOfNextYear
                    )}
                    円/
                    {
                      PERIOD_UNIT[
                      canSend
                        ? chatInputFormik.values.paymentMethodOfNextYear
                        : chatHistory?.paymentMethodOfNextYear
                      ]
                    }
                  </p>
                )}
              {(canSend
                ? ((chatInputFormik.values.updatedInsuranceFeeOfThirdYear || chatInputFormik.values.updatedInsuranceFeeOfThirdYear === 0) &&
                  chatInputFormik.values.paymentMethodOfThirdYear)
                : ((chatHistory?.updatedInsuranceFeeOfThirdYear || chatHistory?.updatedInsuranceFeeOfThirdYear === 0) &&
                  chatHistory?.paymentMethodOfThirdYear)) && (
                  <p className={styles.text}>
                    （長期契約）三年度目保険料：
                    {formatter.format(
                      canSend
                        ? chatInputFormik.values.updatedInsuranceFeeOfThirdYear
                        : chatHistory?.updatedInsuranceFeeOfThirdYear
                    )}
                    円/
                    {
                      PERIOD_UNIT[
                      canSend
                        ? chatInputFormik.values.paymentMethodOfThirdYear
                        : chatHistory?.paymentMethodOfThirdYear
                      ]
                    }
                  </p>
                )}
            </div>
          )}
          {!isOnlyOnePlan() && (
            <>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>プラン①</p>
                <p className={styles.text}>
                  {canSend
                    ? getUpdatedInsuranceLabel(
                      chatInputFormik.values.addOrMinus
                    )
                    : getUpdatedInsuranceLabel(chatHistory?.addOrMinus)}
                  {formatter.format(
                    canSend
                      ? chatInputFormik.values.updatedInsuranceFee
                      : chatHistory?.updatedInsuranceFee
                  )}
                  円
                </p>
                {(canSend
                  ? (chatInputFormik.values.updatedMonthlyInsuranceFee || chatInputFormik.values.updatedMonthlyInsuranceFee === 0)
                  : (chatHistory?.updatedMonthlyInsuranceFee || chatHistory?.updatedMonthlyInsuranceFee === 0)) && (
                    <p className={styles.text}>
                      変更後月払保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.updatedMonthlyInsuranceFee
                          : chatHistory?.updatedMonthlyInsuranceFee
                      )}
                      円
                    </p>
                  )}
                {(canSend
                  ? ((chatInputFormik.values.updatedInsuranceFeeOfNextYear || chatInputFormik.values.updatedInsuranceFeeOfNextYear === 0) &&
                    chatInputFormik.values.paymentMethodOfNextYear)
                  : ((chatHistory?.updatedInsuranceFeeOfNextYear || chatHistory?.updatedInsuranceFeeOfNextYear === 0) &&
                    chatHistory?.paymentMethodOfNextYear)) && (
                    <p className={styles.text}>
                      （長期契約）次年度保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.updatedInsuranceFeeOfNextYear
                          : chatHistory?.updatedInsuranceFeeOfNextYear
                      )}
                      円/
                      {
                        PERIOD_UNIT[
                        canSend
                          ? chatInputFormik.values.paymentMethodOfNextYear
                          : chatHistory?.paymentMethodOfNextYear
                        ]
                      }
                    </p>
                  )}
                {(canSend
                  ? ((chatInputFormik.values.updatedInsuranceFeeOfThirdYear || chatInputFormik.values.updatedInsuranceFeeOfThirdYear === 0) &&
                    chatInputFormik.values.paymentMethodOfThirdYear)
                  : ((chatHistory?.updatedInsuranceFeeOfThirdYear || chatHistory?.updatedInsuranceFeeOfThirdYear === 0) &&
                    chatHistory?.paymentMethodOfThirdYear)) && (
                    <p className={styles.text}>
                      （長期契約）三年度目保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values.updatedInsuranceFeeOfThirdYear
                          : chatHistory?.updatedInsuranceFeeOfThirdYear
                      )}
                      円/
                      {
                        PERIOD_UNIT[
                        canSend
                          ? chatInputFormik.values.paymentMethodOfThirdYear
                          : chatHistory?.paymentMethodOfThirdYear
                        ]
                      }
                    </p>
                  )}
              </div>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>
                  プラン②(車両新価特約付帯プラン)
                </p>
                <p className={styles.text}>
                  {canSend
                    ? getUpdatedInsuranceLabel(
                      chatInputFormik.values.newCarSpecialContractAddOrMinus
                    )
                    : getUpdatedInsuranceLabel(
                      chatHistory?.newCarSpecialContractAddOrMinus
                    )}
                  {formatter.format(
                    canSend
                      ? chatInputFormik.values
                        .newCarSpecialContractUpdatedInsuranceFee
                      : chatHistory?.newCarSpecialContractUpdatedInsuranceFee
                  )}
                  円
                </p>
                {(canSend
                  ? (chatInputFormik.values.newCarSpecialContractUpdatedMonthlyInsuranceFee || chatInputFormik.values.newCarSpecialContractUpdatedMonthlyInsuranceFee === 0)
                  : (chatHistory?.newCarSpecialContractUpdatedMonthlyInsuranceFee || chatHistory?.newCarSpecialContractUpdatedMonthlyInsuranceFee === 0)) && (
                    <p className={styles.text}>
                      変更後月払保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values
                            .newCarSpecialContractUpdatedMonthlyInsuranceFee
                          : chatHistory?.newCarSpecialContractUpdatedMonthlyInsuranceFee
                      )}
                      円
                    </p>
                  )}
                {(canSend
                  ? ((chatInputFormik.values.newCarSpecialContractUpdatedInsuranceFeeOfNextYear || chatInputFormik.values.newCarSpecialContractUpdatedInsuranceFeeOfNextYear === 0) &&
                    chatInputFormik.values.newCarSpecialContractPaymentMethodOfNextYear)
                  : ((chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfNextYear || chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfNextYear === 0) &&
                    chatHistory?.newCarSpecialContractPaymentMethodOfNextYear)) && (
                    <p className={styles.text}>
                      （長期契約）次年度保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values
                            .newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                          : chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfNextYear
                      )}
                      円/
                      {
                        PERIOD_UNIT[
                        canSend
                          ? chatInputFormik.values
                            .newCarSpecialContractPaymentMethodOfNextYear
                          : chatHistory?.newCarSpecialContractPaymentMethodOfNextYear
                        ]
                      }
                    </p>
                  )}
                {(canSend
                  ? ((chatInputFormik.values.newCarSpecialContractUpdatedInsuranceFeeOfThirdYear || chatInputFormik.values.newCarSpecialContractUpdatedInsuranceFeeOfThirdYear === 0) &&
                    chatInputFormik.values.newCarSpecialContractPaymentMethodOfThirdYear)
                  : ((chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfThirdYear || chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfThirdYear === 0) &&
                    chatHistory?.newCarSpecialContractPaymentMethodOfThirdYear)) && (
                    <p className={styles.text}>
                      （長期契約）三年度目保険料：
                      {formatter.format(
                        canSend
                          ? chatInputFormik.values
                            .newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                          : chatHistory?.newCarSpecialContractUpdatedInsuranceFeeOfThirdYear
                      )}
                      円/
                      {
                        PERIOD_UNIT[
                        canSend
                          ? chatInputFormik.values
                            .newCarSpecialContractPaymentMethodOfThirdYear
                          : chatHistory?.newCarSpecialContractPaymentMethodOfThirdYear
                        ]
                      }
                    </p>
                  )}
              </div>
            </>
          )}
        </div>
        <div className={styles.confirmPageTitle}>変更後保険料について</div>
        <div className={styles.confirmPageItemArea}>
          <div className={styles.confirmPageItem}>
            <p className={styles.text}>
              {canSend
                ? chatInputFormik.values.aboutUpdatedInsuranceFeeDetail &&
                chatInputFormik.values.aboutUpdatedInsuranceFeeDetail
                : chatHistory?.aboutUpdatedInsuranceFeeDetail &&
                chatHistory?.aboutUpdatedInsuranceFeeDetail}
            </p>
          </div>
        </div>
        {(canSend ? chatInputFormik.values.remarks : chatHistory?.remarks) && (
          <>
            <div className={styles.confirmPageTitle}>カスタマーセンターからの連絡事項</div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.text}>
                  {canSend ? chatInputFormik.values.remarks : chatHistory?.remarks}
                </p>
              </div>
            </div>
          </>
        )}
        {!canSend && (
          <>
            <div className={styles.confirmPageTitle}>回答</div>
            <div className={styles.confirmPageItemArea}>
              <div className={styles.confirmPageItem}>
                <p className={styles.labelTop}>回答結果</p>
                <p className={styles.text}>
                  {getAcceptanceStatus(chatHistory)}
                </p>
              </div>
              {chatHistory.furtherQuestions && (
                <div className={styles.confirmPageItem}>
                  <p className={styles.labelTop}>確認事項</p>
                  <p className={styles.text}>
                    {chatHistory.furtherQuestions}
                  </p>
                </div>
              )}
            </div>
          </>
        )}
        {canSend && (
          <div className={styles.displayRight}>
            <AsyncButton
              className={styles.confirmButton}
              type='button'
              color='primary'
              variant='contained'
              onClick={() => {
                setConfirmModal(true);
              }}
            >
              送信
            </AsyncButton>
          </div>
        )}
        <ModalWrapper
          open={confirmModal}
          handleClose={() => setConfirmModal(false)}
          scroll={false}
          content={
            <BeforeSendConfirm
              isLongTermContract={
                canSend
                  ? chatInputFormik.values.isLongTermContract
                  : chatHistory?.isLongTermContract
              }
              carInsuranceType={
                canSend
                  ? chatInputFormik.values.carInsuranceType
                  : chatHistory?.carInsuranceType
              }
              closeModal={() => setConfirmModal(false)}
              canSend={true}
              onClick={() => chatInputFormik.handleSubmit()}
              loading={isChatSubmitInProgress}
            />
          }
        />
      </div>
    </>
  );
};

export default ChatInputConfirm;
